<template>
  <div class="container">
    <footer id="footer">
      <div class="row">
        <div class="col-xs-12 col-md-2 copyrights">
          <p>&COPY; 2021 Alan Labs</p>
        </div>
        <div class="col-xs-12 col-md-10 footer-socials">
          <router-link to="/terms">Terms and Conditions</router-link>
          <router-link to="/grants">Grant Program Terms</router-link>
          <a href="mailto:nft@hashpandas.com">Contact Us</a>

            <span class="col-xs-2 col-md-12 ">  {{$t('menu.WeChat')}}：hashpandas</span>

        </div>

      </div>
    <div class="row">
        <div class="col-xs-10 col-md-10 footer-socials">
           <!-- <span class="col-xs-2 col-md-12 copyrights">DouYin：hashpandas</span> -->
         <!-- <a href="https://discord.gg/sh9dpEruVP">Disclaimer</a> -->
          <!-- <a href=""
            ><img class="footer-social-icon" src="/images/discord.png"
          /></a>  -->

          
           <a href="https://v.douyin.com/eQJHQca/"
            ><img class="footer-social-icon" src="/images/dy.jpeg"
          /></a>

          <a href="https://www.instagram.com/nft.hashpandas/"
            ><img class="footer-social-icon" src="/images/instagram.jpeg"
          /></a>

          <a href="https://t.me/joinchat/c97YoTZt5XJlODQ9"
            ><img class="footer-social-icon" src="/images/tg.jpeg"
          /></a>
            <a href="https://weibo.com/u/5671842226"
            ><img class="footer-social-icon" src="/images/weibo.jpeg"
          /></a>
          <a href="https://twitter.com/HashPandas"
            ><img class="footer-social-icon" src="/images/twitter.png"
          /></a>
           <a href="https://www.facebook.com/profile.php?id=100069016534052"
            ><img class="footer-social-icon" src="/images/facebook.jpeg"
          /></a>
           
           
          <a href="https://hashpandas.medium.com/"
            ><img class="footer-social-icon" src="/images/medium.png"
          /></a>


        </div>

    </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Footer',
};
</script>

<style></style>
